import { FormControl, FormField, FormItem, FormMessage } from "@/components/_components/form";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/_components/table";
import { SUPPLEMENT_ADDITIONAL_ATTR } from "@/constants/constants";
import { Control } from "react-hook-form";

interface AdditionalAttributesTableProps {
  control: Control<any>;
  selectedType: string;
  onAttributeChange: (key: string, value: string) => void;
}

const AdditionalAttributesTable = ({
  control,
  selectedType,
  onAttributeChange,
}: AdditionalAttributesTableProps) => {
  // Filter attributes based on selected type
  const relevantAttributes = SUPPLEMENT_ADDITIONAL_ATTR.filter(
    (attr) => attr.value === selectedType
  );

  if (relevantAttributes.length === 0) {
    return null;
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">Additional Attributes</h3>
        <p className="text-sm text-gray-600">Configure additional attributes for this {selectedType}</p>
      </div>
      
      <div className="border rounded-lg">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-1/3">Attribute</TableHead>
              <TableHead>Value</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {relevantAttributes.map((attr) => (
              <TableRow key={attr.key}>
                <TableCell className="font-medium">
                  {attr.label}
                  {attr.mandatory && <span className="text-red-500 text-base font-bold ml-1">*</span>}
                </TableCell>
                <TableCell>
                  <FormField
                    control={control}
                    name={`additionalAttributes.${attr.key}`}
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          <input
                            placeholder={`Enter ${attr.label.toLowerCase()}...${attr.mandatory ? ' (required)' : ''}`}
                            value={field.value || ""}
                            onChange={(e) => {
                              field.onChange(e.target.value);
                              onAttributeChange(attr.key, e.target.value);
                            }}
                            type={attr.type === "email" ? "email" : "text"}
                            required={attr.mandatory}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default AdditionalAttributesTable;